import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const stats = [
  { value: "222", label: "累计鉴定条目" },
  { value: "68", label: "已更新反转" },
  { value: "1.2万", label: "本周线索投稿" },
];

export default function Hero() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  function onSearch(e: FormEvent) {
    e.preventDefault();
    const q = query.trim();
    navigate(q ? `/verify?q=${encodeURIComponent(q)}` : "/verify");
  }

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20fanned%20newspaper%20clippings%20a%20magnifying%20glass%20and%20a%20red%20verdict%20stamp%20on%20a%20warm%20cream%20desk%2C%20dramatic%20amber%20side%20light%2C%20investigative%20journalism%20mood%2C%20rich%20texture%2C%20cinematic%20shadows&width=1600&height=900&seq=hero-17-baoliao&orientation=landscape"
          alt="报纸剪报、放大镜与鉴定印章的桌面场景"
          className="h-full w-full object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85"></div>

      <div className="relative mx-auto flex w-full flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-400/50 bg-primary-500/15 px-4 py-1.5 text-xs font-500 tracking-wide text-primary-100">
          <i className="ri-flashlight-line"></i>
          跟踪辟谣 · 反转 · 打脸现场
        </span>

        <h1 className="font-heading text-4xl font-900 leading-tight tracking-tight text-background-50 md:text-6xl">
          17爆料网
          <span className="mt-3 block text-xl font-600 text-primary-200 md:text-3xl">真假鉴定专区</span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          站内汇总当事人澄清、后续回应与最新进展，帮你判断哪些料站得住，哪些已经翻车。
        </p>

        <form onSubmit={onSearch} className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row">
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-lg text-foreground-400"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              aria-label="搜索爆料关键词"
              placeholder="输入关键词，如“奶茶”“天价门票”"
              className="w-full rounded-md border border-background-300/40 bg-background-50/95 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-300/50"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-500 text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索鉴定
          </button>
        </form>

        <div className="mt-12 grid w-full max-w-2xl grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-200/25 bg-background-50/10 px-4 py-4 backdrop-blur-sm"
            >
              <div className="font-label text-2xl font-600 text-accent-300 md:text-3xl">{s.value}</div>
              <div className="mt-1 text-xs text-background-200 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}